<!-- バックヤード > タグ追加 -->
<template>
  <div>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <tag-form
      v-if="tag"
      :tag="tag"
      :is-edit="false"
    />
  </div>
</template>

<script>
  import Utils from "../../../mixins/Utils";
  import TagForm from './_Form'
  import {mapActions} from "vuex";

  export default {
    name: 'TagsNew',
    components: {
      TagForm,
    },
    mixins: [
      Utils,
    ],
    data () {
      return {
        breadcrumbs: [
          { text: 'タグ一覧', disabled: false, to: '/backyard/tags', exact: true },
          { text: 'タグ新規', disabled: true, to: '' },
        ],
        tag: null,
      }
    },
    created() {
      this.newTag().then((content) => {
        this.tag = content
      })
    },
    methods: {
      ...mapActions('backTag', {
        newTag: 'new'
      })
    },
  }
</script>

<style lang="scss">

</style>
